export const HUBSPOT_EMAIL_FORM_SUBMITTED_KEY = "hubspot-email-form-submitted";
